import * as React from 'react';

import { DataGrid, GridActionsCellItem  } from '@mui/x-data-grid';
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
} from '@mui/x-data-grid';

import DeleteIcon from '@mui/icons-material/Delete';
import { LicenseInfo } from '@mui/x-data-grid-pro';
const REACT_APP_GRID = process.env.REACT_APP_GRID
LicenseInfo.setLicenseKey(REACT_APP_GRID);

export default function ShelfCycleScanGrid(props) {

    const deleteProduct = React.useCallback( (sentID) => async () => {
        //get index of the product in the array
        var index = props.gridData.findIndex(x => x.id === sentID)
        var currentSerialNumber = props.gridData[index]
        currentSerialNumber = currentSerialNumber.serialNum
        // remove items from currentProducts
        var currentProducts = [...props.gridData]
        currentProducts.splice(currentProducts.id === sentID, 1)
        // remove product from the grid and update the state of validSerialNumbers
        props.handleRemoveProduct(currentProducts, currentSerialNumber)
    },
    [props], );

    function CustomToolbar() {
      return (
        <GridToolbarContainer>
          {/* <GridToolbarColumnsButton /> */}
          <GridToolbarFilterButton />
          {/* <GridToolbarDensitySelector /> */}
          <GridToolbarExport />
        </GridToolbarContainer>
      );
    }

    const [selectedModel, setSelectedModel ] = React.useState();
    const  GridData  = {
        columns: [
            {field: 'id', hide: true},
            {field: 'productId', headerName: 'Product Number', align:'center', headerAlign: 'center', width:150, editable: false},
            {field: 'productName', headerName: 'Product Name', align:'center', headerAlign: 'center', width:250, editable: false},
            {field: 'serialNum', hide: !props.eventAccountSerialType, headerName: 'Serial Number', align:'center', headerAlign: 'center', width:150, editable: false},
            {field: 'shelfNum', headerName: 'Shelf Number', align:'center', headerAlign: 'center', width:150, editable: false},
            {field: 'actions', type: 'actions', headerName: 'Delete', width:75,  align:'center', headerAlign: 'center',
            getActions: (params) => [
                <GridActionsCellItem icon={<DeleteIcon />} onClick={deleteProduct(params.id)}  label="Delete" />
            ]},
      ], 
      rows: props.gridData
      };

  return (

    <div style={{ height: 300, width: '100%' }}>
      <DataGrid 
      onSelectionModelChange={(newSelectionModel) => {
        setSelectedModel(newSelectionModel)
        // props.handleMarketFileNames(newSelectionModel)
      }}
      selectedModel={selectedModel}
      {...GridData} 
      components={{
        Toolbar: CustomToolbar,
      }}
      />
    </div>

  );
};